// eslint-disable-next-line unicorn/prevent-abbreviations
import { usePandaDocSigningEnabled } from "@src/appV2/redesign/Documents/Details/Workflows/PandaDoc/usePandaDocSigningEnabled";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useParams } from "react-router-dom";

import { type HelloSignModalRoutePathParams } from "../../../../ShiftDiscovery/types";
import { InstantReviewHelloSignFormBottomSheet } from "./HelloSignFormBottomSheet";
// eslint-disable-next-line unicorn/prevent-abbreviations
import { InstantReviewPandaDocFormBottomSheet } from "./PandaDocFormBottomSheet";

interface InstantReviewSignFormBottomSheetProps {
  modalState: UseModalState;
}

export function InstantReviewSignFormBottomSheet(props: InstantReviewSignFormBottomSheetProps) {
  const { modalState } = props;
  const { requirementId } = useParams<HelloSignModalRoutePathParams>();
  // eslint-disable-next-line unicorn/prevent-abbreviations
  const isPandaDocEnabled = usePandaDocSigningEnabled(requirementId);

  if (isPandaDocEnabled) {
    return <InstantReviewPandaDocFormBottomSheet modalState={modalState} />;
  }

  return <InstantReviewHelloSignFormBottomSheet modalState={modalState} />;
}
